<app-pagetoolbar *ngIf="matchRun" icon="autorenew" [label]="'Matchrun #' + matchRun.runNumber + ' of ' + matchingPeriod.matchingPeriodName"> </app-pagetoolbar>
<div class="container" *ngIf="matchRun">
  <button *ngIf="previousMatchRun" class="nav-button left" (click)="navigateTo(previousMatchRun.runNumber)">
    <mat-icon>keyboard_arrow_left</mat-icon>
    {{ previousMatchRun.runNumber || "--" }}
  </button>

  <button *ngIf="nextMatchRun" class="nav-button right" (click)="navigateTo(nextMatchRun.runNumber)">
    {{ nextMatchRun.runNumber }}
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
<ng-template #loading>Loading match result...</ng-template>
<ng-container *ngIf="matchRun; else loading">
  <div class="page-buttons">
    <button mat-fab class="print" color="primary" (click)="getExcelFiles()" *ngIf="canAccessDownloads">
      <mat-icon>file_download</mat-icon>
    </button>

    <button mat-fab class="print" color="primary" (click)="getSettings()" *ngIf="canAccessSettings">
      <mat-icon>settings</mat-icon>
    </button>

    <mat-menu #mailMenu="matMenu">
      <a mat-menu-item target="_blank" matTooltip="Centers that have entered at least one pair in this matchrun"> <mat-icon>mail_outline</mat-icon>Centers in matchrun </a>
      <a mat-menu-item target="_blank" matTooltip="Centers where at least one pair was selected in a chain"> <mat-icon>mail</mat-icon>Centers selected </a>
      <a mat-menu-item target="_blank" matTooltip="Centers that have entered at least one pair, but where no pair was selected in any chain"> <mat-icon>unsubscribe</mat-icon>Centers not selected </a>
    </mat-menu>

    <button mat-fab color="primary" matTooltip="Start new matchrun" (click)="startNewMatchrun()" *ngIf="canStartMatchrun && !nextMatchRun && !isMatchRunInProgress">
      <mat-icon mat-list-icon>play_arrow</mat-icon>
    </button>
  </div>

  <!-- Summary for successful matches (only show if no errors and has matches) -->
  <mat-card class="summary" *ngIf="!hasNoMatches && !matchRun?.hasErrors">
    <mat-card-content class="summary-content">
      <div class="summary-block">
        <div class="digit">
          {{ matchRun.matchData.length > 0 ? matchRun.matchData.length / 2 : matchRun.matchData.length }}
        </div>
        <div class="caption">potential transplants</div>
      </div>
      <div class="summary-block greyline">
        <div class="digit">{{ maxChains }}</div>
        <div class="caption">chains</div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- No matches found message (only show if no errors and no matches) -->
  <mat-card class="no-matches" *ngIf="hasNoMatches && !matchRun?.hasErrors">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>info</mat-icon>
        No Matches Found
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>The algorithm completed successfully but found no potential matches using this dataset.</p>
      <div class="run-info">
        <h4>Run Information:</h4>
        <div class="info-row">
          <span class="label">Recipients:</span>
          <span class="value">{{ matchRun.recipients || 0 }}</span>
        </div>
        <div class="info-row">
          <span class="label">Altruistic Donors:</span>
          <span class="value">{{ matchRun.altruists || 0 }}</span>
        </div>
        <div class="info-row">
          <span class="label">Run Date:</span>
          <span class="value">{{ getFormattedDate(matchRun.dateCreated) }}</span>
        </div>
        <div class="info-row" *ngIf="matchRun.userStarted">
          <span class="label">Started by:</span>
          <span class="value">{{ matchRun.userStarted }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Algorithm errors message -->
  <mat-card class="algorithm-errors" *ngIf="matchRun && matchRun.hasErrors">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>error</mat-icon>
        Algorithm Errors Detected
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>The algorithm encountered errors during execution. Please review the details below:</p>
      <div class="error-details">
        <h4>Error Messages:</h4>
        <div class="error-list">
          <div class="error-item" *ngFor="let error of getAlgorithmErrors()">
            <mat-icon class="error-icon">warning</mat-icon>
            <span class="error-text">{{ error }}</span>
          </div>
        </div>
      </div>
      <div class="run-info">
        <h4>Run Information:</h4>
        <div class="info-row">
          <span class="label">Recipients:</span>
          <span class="value">{{ matchRun.recipients || 0 }}</span>
        </div>
        <div class="info-row">
          <span class="label">Altruistic Donors:</span>
          <span class="value">{{ matchRun.altruists || 0 }}</span>
        </div>
        <div class="info-row">
          <span class="label">Run Date:</span>
          <span class="value">{{ getFormattedDate(matchRun.dateCreated) }}</span>
        </div>
        <div class="info-row" *ngIf="matchRun.userStarted">
          <span class="label">Started by:</span>
          <span class="value">{{ matchRun.userStarted }}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="readonly-reason" *ngIf="nextMatchRun || isMatchRunInProgress"> {{ "Historical" }} matchrun of {{ matchingPeriod.matchingPeriodName }} cycle </mat-card>

  <mat-card class="readonly-reason" *ngIf="!nextMatchRun && !isMatchRunInProgress"> {{ "Latest" }} matchrun of {{ matchingPeriod.matchingPeriodName }} cycle </mat-card>

  <!-- Display matchrun comment if it exists -->
  <mat-card class="matchrun-comment" *ngIf="canViewComments && matchRun?.comment">
    <mat-card-header (click)="toggleCommentExpanded()" style="cursor: pointer;">
      <mat-card-title>
        <mat-icon>comment</mat-icon>
        Matchrun Comment
        <mat-icon class="expand-icon">{{ isCommentExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="isCommentExpanded">
      <p class="comment-text">{{ matchRun.comment }}</p>
      <div class="comment-meta" *ngIf="nextMatchRun">
        <span *ngIf="nextMatchRun.userStarted">Started by: <strong>{{ nextMatchRun.userStarted }}</strong></span>
        <span *ngIf="nextMatchRun.dateCreated"> • {{ getFormattedDate(nextMatchRun.dateCreated) }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<!-- Only show chains if there are matches and no errors -->
<ng-container *ngIf="!hasNoMatches && !matchRun?.hasErrors">
  <div *ngFor="let chain of groupedMatchData | keyvalue: compareChainNumbers">
    <app-match-chain
      [data]="chain.value"
      [chainNumber]="chain.key"
      [matchRunNumber]="matchRun.runNumber.toString()"
      [matchRunId]="matchRun.id"
      [allParticipants]="participants"
      [currentMatchRunDate]="matchRun.dateCreated"
      [nextMatchRunDate]="nextMatchRun?.dateCreated"
      [isHistoricalMatchRun]="!!nextMatchRun || isMatchRunInProgress"
      [crossmatches]="getChainData(chain.key)?.crossmatches"
      [chainStatus]="getChainData(chain.key)?.chainStatus">
    </app-match-chain>
  </div>
</ng-container>
